import { MaskedLine, FadeIn } from "./Reveal";

export const PageHero = ({ eyebrow, lines, sub, children, dark = false }) => (
  <section className={`relative overflow-hidden ${dark ? "bg-night text-sand" : ""}`}>
    <div className="mx-auto max-w-7xl px-4 pb-14 pt-36 sm:px-8 sm:pb-20 sm:pt-44 lg:px-16">
      <FadeIn delay={0.1}>
        <p className={`font-mono text-xs uppercase tracking-[0.3em] ${dark ? "text-gold" : "text-gold-dark"}`}>
          {eyebrow}
        </p>
      </FadeIn>
      <h1 className="headline mt-5 font-display text-4xl font-extrabold leading-[1.04] tracking-tight sm:text-6xl lg:text-7xl">
        {lines.map((line, i) => (
          <MaskedLine key={i} delay={0.15 + i * 0.13}>
            {line}
          </MaskedLine>
        ))}
      </h1>
      {sub && (
        <FadeIn delay={0.6}>
          <p
            className={`mt-7 max-w-2xl font-serif text-lg italic leading-relaxed sm:text-2xl ${
              dark ? "text-sand/60" : "text-smoke"
            }`}
          >
            {sub}
          </p>
        </FadeIn>
      )}
      {children && <FadeIn delay={0.75}>{children}</FadeIn>}
    </div>
  </section>
);
